<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="Orion_lock-opened">
      <path
        id="layer2"
        d="M4.75 7.5V3.75C4.75 2.88805 5.09241 2.0614 5.7019 1.4519C6.3114 0.84241 7.13805 0.5 8 0.5C8.86195 0.5 9.6886 0.84241 10.2981 1.4519C10.9076 2.0614 11.25 2.88805 11.25 3.75V4.2"
        stroke="currentColor"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />

      <path
        id="layer1"
        d="M8 10.25V12.75"
        stroke="currentColor"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />

      <path
        id="layer1_2"
        d="M12 7.5H4C3.17157 7.5 2.5 8.17157 2.5 9V14C2.5 14.8284 3.17157 15.5 4 15.5H12C12.8284 15.5 13.5 14.8284 13.5 14V9C13.5 8.17157 12.8284 7.5 12 7.5Z"
        stroke="currentColor"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
  </svg>
</template>
